

import { Collapse } from 'antd';
import React, {useState, useEffect} from 'react';
import { copyCollection, firestore } from "./utils/database";
import sendEmail from "./utils/email";

import { Affix, Button, Card, Checkbox, Divider, Form, Input, message, PageHeader, Pagination, Progress, Typography, Popover, Radio, Select, Slider, Steps } from "antd";

import fetchLikedContent, {conf_ID, getConferenceContent} from "./utils/misc";

const { Panel } = Collapse;
const { Option } = Select;
const { Step } = Steps;
const { Text } = Typography;

let already_answered = [];

const Admin = () => {
    const [displayQFlag, setDisplayQFlag] = useState(false);
    const [user, setUser] = useState({});
    const [users, setUsers] = useState([]);
    const [researcher, setResearcher] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [minIndex, setMinIndex] = useState(0);
    const [maxIndex, setMaxIndex] = useState(5);
    const [topicEnabled, setTopicEnabled] = useState(true);

    const [form] = Form.useForm();

    const [messageApi, contextHolder] = message.useMessage();

    const stage_dict = {"undergraduate": "a undergraduate student", "graduate": "a graduate student", "postdoc": "post-doc", "faculty": "professor", "industry": "researcher", "other": "researcher"};
    
    

    useEffect(() => {
        // downloadPaper({"id":"u8a2s1swi0SFOqAFwMazrfgsn3K2"}, "69038709");
    }, [])

    const emailIncomplete = async () => {
        // const ur = await firestore.collection("settings").doc("bngspntR9AYDUwJLayk923F63qg2");
        // const uu = await ur.get();
        // sendIncomplete(uu.data());

        const delay = ms => new Promise(res => setTimeout(res, ms));

        const usersRef = await firestore.collection("data")
        .get().then(async (s) => {
            for(const d of s.docs) {
                const user = d.data();
                
                if(!user.token) {
                    continue;
                }

                console.log("email to complete signing up", user['name'], user['email'], "https://academic-matching.netlify.app/label?id="+d.id);
                // sendEmail(user['name'], user['email'], "https://academic-matching.netlify.app/label?id="+d.id);
                await delay(1100);
            }
        })
    }

    const getUrlParameter = (sParam) => {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    const saveSuccess = () => {
        // messageApi.open({
        //   type: 'success',
        //   content: 'Your response is autosaved',
        // });
      };

  const downloadPaper = (user, ssUrl) => {
    let query_url= `https://api.semanticscholar.org/graph/v1/author/${ssUrl}?fields=name,papers.authors,papers.title,papers.url,papers.year,papers.journal,papers.fieldsOfStudy,papers.abstract,affiliations,paperCount`;
    fetch(query_url, {
        headers: {
            // 'Ocp-Apim-Subscription-Key': process.env.REACT_APP_MAG_SUB_KEY,
            'Content-Type': 'application/json',
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'x-api-key': 'DIjEjQlI8x2zjnYM6Ehgw9jIsGnYl0ql86pat70w',
        }
    })
    .then(res => res.json())
    .then(paper_list => {
        // process the recent papers
        let papers = {};
        const non_arxivs = paper_list["papers"] // .filter(p =>  !("VFN" in p && p["VFN"].includes("arXiv")));
        if(true) {
            const d = new Date();
            
            non_arxivs.sort((a,b) => b.year - a.year);
            non_arxivs
                .map(p => {
                papers[p["paperId"]]= {
                    "author_mag_id": ssUrl, 
                    "title": p["title"],
                    "authors": p["authors"],
                    "year": p["year"],
                    "conference": p["journal"]? (p["journal"]["name"] || "") : "",
                    "abstract": p["abstract"]
                }
                return null;
            })

            
        }

        user["prev_papers"] = papers;
        firestore.collection('responses').doc(user.id).set(user, {merge:true});
    })
  }

  return (
      <>
        <button onClick={() => emailIncomplete()}>Email to incomplete user</button>
    </>
  );
};
export default Admin;